import React from 'react'
import { differenceInDays, format, isValid, parse } from 'date-fns'
import AdxDateRangePicker from 'components/reusable/AdxDateRangePicker'

const DATE_FORMAT = 'dd/MM/yyyy'
const noop = () => {}

const toPickerString = (value) => {
  if (!value || !(value instanceof Date) || Number.isNaN(value.getTime())) return ''
  return format(value, DATE_FORMAT)
}

const toPickerDate = (value) => {
  if (!value) return null
  const parsed = parse(value, DATE_FORMAT, new Date())
  return isValid(parsed) ? parsed : null
}

const getDuration = (startDate, endDate) => {
  if (!startDate || !endDate) return 0
  return differenceInDays(endDate, startDate) + 1
}

export default function TaskWorkingPeriodPicker({
  label = 'Working Period',
  name = 'workingPeriod',
  required = false,
  startDate = null,
  endDate = null,
  projectStartDate = null,
  projectDeadline = null,
  dueDate = null,
  disabled = false,
  disablePast = false,
  startError = '',
  endError = '',
  onChange,
}) {
  const latestAllowedDate =
    dueDate && projectDeadline
      ? dueDate.getTime() <= projectDeadline.getTime()
        ? dueDate
        : projectDeadline
      : dueDate || projectDeadline || null

  const values = {
    startDate: toPickerString(startDate),
    endDate: toPickerString(endDate),
    duration: getDuration(startDate, endDate),
  }

  const helperText = startError || endError || ''
  const isErrorShown = Boolean(helperText)
  const displayLabel = label ? (required ? `${label} *` : label) : ''
  const pickerKey = `${name}-${values.startDate || 'empty-start'}-${values.endDate || 'empty-end'}`

  return (
    <AdxDateRangePicker
      key={pickerKey}
      label={displayLabel}
      name={name}
      disabled={disabled}
      disablePast={disablePast}
      startCycle={projectStartDate || undefined}
      endCycle={latestAllowedDate || undefined}
      values={values}
      setValue={(range) => {
        const parsedStart = toPickerDate(range?.startDate)
        const parsedEnd = toPickerDate(range?.endDate)

        onChange?.({
          startDate: parsedStart,
          endDate: parsedEnd,
          duration: range?.duration || getDuration(parsedStart, parsedEnd),
        })
      }}
      errorMessage={helperText}
      isErrorShown={isErrorShown}
      validateField={noop}
    />
  )
}
